import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateCodeBrowserColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

import BlueprintsFeatureGateTooltip from "./FeatureGate/Tooltip";
import { BlueprintActions } from "./FeatureGate/types";

type BlueprintsEmptyProps = {
  hasNoResults?: boolean;
  onCreate: () => void;
};

const BlueprintsEmpty = ({ hasNoResults, onCreate }: BlueprintsEmptyProps) => {
  return (
    <>
      {hasNoResults && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoResults && (
        <EmptyState
          title="You don’t have any blueprints yet"
          icon={EmptystateCodeBrowserColored}
          caption={`Blueprints are "stack factories". They can be used by your teammates to quickly provision
          a stack by filling out a simple form.`}
        >
          <Box gap="medium">
            <DocumentationButton to={getDocsUrl("/concepts/blueprint")} label="Documentation" />
            <BlueprintsFeatureGateTooltip
              action={BlueprintActions.CreateBlueprint}
              on={({ isDisabled, ...props }) => (
                <Button {...props} variant="primary" onPress={onCreate} disabled={isDisabled}>
                  Create blueprint
                </Button>
              )}
            />
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default BlueprintsEmpty;
